import IconHOC from '../IconHOC';

import { ReactComponent as ExternalLinkIcon } from './externalLink.svg';

export const ExternalLink = IconHOC(ExternalLinkIcon);
